import { URL, handleErrors } from "./depannageActions"
import { catchApiError } from "./apiHelpers"

// Cockpit ---------------------------------------------------------------------
export const FETCH_STATSV2_COCKPIT_BEGIN = "FETCH_STATSV2_COCKPIT_BEGIN"
export const FETCH_STATSV2_COCKPIT_SUCCESS = "FETCH_STATSV2_COCKPIT_SUCCESS"
export const FETCH_STATSV2_COCKPIT_ERROR = "FETCH_STATSV2_COCKPIT_ERROR"

export const fetchStatsV2CockpitBegin = () => ({
	type: FETCH_STATSV2_COCKPIT_BEGIN,
})
export const fetchStatsV2CockpitSuccess = (cockpit) => ({
	type: FETCH_STATSV2_COCKPIT_SUCCESS,
	payload: { cockpit },
})
export const fetchStatsV2CockpitError = (error) => ({
	type: FETCH_STATSV2_COCKPIT_ERROR,
	payload: { error },
})

export function fetchStatsV2Cockpit({ dateS, dateE, basis }) {
	const url = `${URL}api/stats-v2/cockpit?dateS=${dateS}&dateE=${dateE}&basis=${basis}`
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchStatsV2CockpitBegin())
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(fetchStatsV2CockpitSuccess(json)))
			.catch(catchApiError(dispatch, fetchStatsV2CockpitError))
	}
}

// Tendances -------------------------------------------------------------------
export const FETCH_STATSV2_TENDANCES_BEGIN = "FETCH_STATSV2_TENDANCES_BEGIN"
export const FETCH_STATSV2_TENDANCES_SUCCESS = "FETCH_STATSV2_TENDANCES_SUCCESS"
export const FETCH_STATSV2_TENDANCES_ERROR = "FETCH_STATSV2_TENDANCES_ERROR"

export const fetchStatsV2TendancesBegin = () => ({
	type: FETCH_STATSV2_TENDANCES_BEGIN,
})
export const fetchStatsV2TendancesSuccess = (tendances) => ({
	type: FETCH_STATSV2_TENDANCES_SUCCESS,
	payload: { tendances },
})
export const fetchStatsV2TendancesError = (error) => ({
	type: FETCH_STATSV2_TENDANCES_ERROR,
	payload: { error },
})

export function fetchStatsV2Tendances({ anneeDebut, anneeFin, basis }) {
	const url = `${URL}api/stats-v2/tendances?anneeDebut=${anneeDebut}&anneeFin=${anneeFin}&basis=${basis}`
	return async (dispatch, getState) => {
		const { token } = getState().navInfo.login
		dispatch(fetchStatsV2TendancesBegin())
		return fetch(url, { headers: { Authorization: `Bearer ${token}` } })
			.then(handleErrors)
			.then((res) => res.json())
			.then((json) => dispatch(fetchStatsV2TendancesSuccess(json)))
			.catch(catchApiError(dispatch, fetchStatsV2TendancesError))
	}
}
